/* Component Dependencies */
var socialMediaTemplate = require('templates/socialMedia.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'socialMedia',
    template: {
        'socialMedia': socialMediaTemplate
    }
});